import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeItem } from 'src/app/models/home-item';
import icon from './constants/icon';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  iconlist: HomeItem[] = icon;
  constructor(private route: Router) { }


  ngOnInit(): void {
    // This is intentional
  }
  homeRouter(iconObject:HomeItem){
    this.route.navigate([`/${iconObject.link}`], { replaceUrl: true });
  }
}
